import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BackupConfigureComponent } from './backup-configure/backup-configure.component';
import { CustomProductComponent } from './custom-product/custom-product.component';
import { ClientConfigComponent } from './client-config.component';
import { SnAuthGuard } from '@insight/serenity-auth';
import { PersonaGuard } from '../auth/authguards/persona-guard';


const routes: Routes = [
  {
    path: 'client-configure',
    component: ClientConfigComponent,
    children: [
      { path: "backup-fields/:clientId", component: BackupConfigureComponent, canActivate: [SnAuthGuard, PersonaGuard]},
      { path: "custom-products/:clientId", component: CustomProductComponent, canActivate: [SnAuthGuard, PersonaGuard]}
    ],
    canActivate: [SnAuthGuard, PersonaGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class ClientConfigRoutingModule { }
